import React from 'react';
import styles from './styles/NotificacaoErro.module.css';

const NotificacaoErro = ({ message, show }) => {
    return (
        <div className={`${styles.notificacao} ${show ? styles.mostrar : ''}`}>
            {message}
        </div>
    );
};

export default NotificacaoErro;